module.exports = __webpack_public_path__ + "static/media/piggy-bank.702f055e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/montemar-card-calf/img/piggy-bank.png
 ** module id = 2058
 ** module chunks = 0
 **/